import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, DocumentTextOutline, Flex, Link, PhotographOutline, Text, useDisclosure } from '@bonusly/design-system';

import { AttachmentModal } from './attachment-modal';

interface AttachmentButtonProps {
	attachment?: {
		filename?: string | null;
		type?: string | null;
		url?: string | null;
	};
}

const AttachmentButton: FC<AttachmentButtonProps> = ({ attachment }) => {
	const { t } = useTranslation('admin', {
		keyPrefix: 'incentives.summary',
	});
	const { isOpen, onClose, onOpen } = useDisclosure();

	if (!attachment || !attachment.url) {
		return '-';
	}

	if (attachment.type === 'application/pdf') {
		return (
			<Flex>
				<DocumentTextOutline color="secondary.fg" mr={2} />
				<Link
					href={attachment.url}
					target="_blank"
					color="primary.fg"
					fontWeight="medium"
					overflow="hidden"
					_hover={{ color: 'primary.fgStrong', textDecoration: 'underline' }}
				>
					{attachment.filename || t('view_pdf')}
				</Link>
			</Flex>
		);
	}

	return (
		<Flex>
			<PhotographOutline color="secondary.fg" mr={2} />
			<Button variant="link" colorScheme="primary" onClick={onOpen} borderRadius={0}>
				<Text overflow="hidden" textAlign="left" whiteSpace="normal">
					{attachment.filename || t('view_image')}
				</Text>
			</Button>
			<AttachmentModal isOpen={isOpen} onClose={onClose} url={attachment.url} />
		</Flex>
	);
};

export { AttachmentButton };
